import { ComponentType, lazy, memo, Suspense } from 'react'
// import ProgressBar from 'react-topbar-progress-indicator'

const ProgressBar = () => <></>
// import palette from 'styles/theme/palette'

// ProgressBar.config({
//   barColors: {
//     0: palette.primary.main,
//     1: palette.secondary.main,
//   },
//   shadowBlur: 2,
// })

export default function lazyLoad<TProps>(
  importFunc: () => Promise<{ default: ComponentType<TProps> }>,
  { fallback = null } = {},
) {
  const LazyComponent = lazy(() =>
    importFunc().catch(() => {
      console.error('LazyLoading failed; Reloading the app to fetch the newest index.html version')
      window.location.reload()
      return {
        default: ProgressBar,
      }
    }),
  )
  return memo((props: TProps) => (
    <Suspense fallback={fallback || <ProgressBar />}>
      {/*@ts-ignore*/}
      <LazyComponent {...props} />
    </Suspense>
  ))
}
